import { NgModule } from '@angular/core';
import { Facebook } from '@awesome-cordova-plugins/facebook/ngx';
import { Keychain } from '@awesome-cordova-plugins/keychain/ngx';
import { SignInWithApple } from '@awesome-cordova-plugins/sign-in-with-apple/ngx';

@NgModule({
  providers: [Keychain, SignInWithApple, Facebook],
})
export class AuthModule {}
